/* eslint-disable no-promise-executor-return */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable arrow-spacing */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-void */
/* eslint-disable no-restricted-syntax */
/* eslint-disable quote-props */
/* eslint-disable no-console */
/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";

import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import InfoIcon from "@mui/icons-material/Info";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";
import { USER_IMAGE } from "../../mock/base64/user";

import { useScreenSize } from "../../component/Theme";
import Agreement from "./modal/Agreement";
import PasswordReminder from "./modal/PasswordReminder";
import BasicButton from "../../component/button/BasicButton";
import backImage from "../../images/background.png";

import SompoContext from "../../logic/context/SompoContext";
import LoginService, {
    ERROR_ACCESS_LIMIT,
    ERROR_PASSWORD_POLICY,
    ERROR_PASSWORD_EXPIRED,
    ERROR_MESSAGE_PASSWORD_EXPIRED,
    LoginPayload,
    LoginResponse,
} from "../../logic/api/LoginService";
import { login, logout } from "../../logic/authorization/Authorization";
import UserDetailService, { UserDetailResponse } from "../../logic/api/UserDetailService";
import UserSelectListService, { User } from "../../logic/api/UserSelectListService";
import UserImageDownloadService from "../../logic/api/UserImageDownloadService";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { DateFormats, formatJSDate } from "../../logic/datetime";

export const LoginTextField = styled(TextField)({
    "& label.Mui-focused": {
        color: "#c00000",
    },
    "& .MuiOutlinedInput-root": {
        background: "#F3F3F4",
        "&:hover fieldset": {
            borderColor: "#c00000",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#c00000",
        },
    },
});

const loginService = new LoginService();
const userService = new UserSelectListService();
const userDetailService = new UserDetailService();
const userImageService = new UserImageDownloadService();

interface NavigateUrlProps {
    navigateUrl: string;
    preNavigate?: () => Promise<boolean>;
}

export default function Login(props: NavigateUrlProps) {
    const sompoContext = React.useContext(SompoContext);
    const theme = useTheme();
    const { desktop } = useScreenSize();
    const navigate = useNavigate();
    const { navigateUrl, preNavigate } = props;

    useEffect(() => {
        logout();
    }, []);
    // ↓ ログイン画面で使用 ↓
    const [formValues, setFormValues] = useState<LoginPayload>({ loginId: "", password: "" });
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [infoVisible, setInfoVisible] = useState(false);

    // 入力時のイベント
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues({ ...formValues, [event?.target.name]: event?.target.value });
    };

    // パスワードの表示切替
    const handleClickShowPassword = () => {
        setPasswordVisible(!passwordVisible);
    };

    // お知らせの表示切替
    const handleClickShowInfo = () => {
        setInfoVisible(!infoVisible);
    };

    // 利用規約モーダルで使用
    const [agreementOpen, setAgreementOpen] = useState(false);

    // ↓パスワード再発行モーダルで使用
    const [reminderOpen, setReminderOpen] = useState(false);

    // ログイン時、トークンをセットしてhomeまたは講座詳細へ遷移する
    const loginNavigate = () => {
        const _navigate = async () => {
            if (preNavigate) {
                const valid = await preNavigate();
                if (!valid) return;
            }
            navigate(navigateUrl);
        };
        void _navigate();
    };

    // パスワードポリシーに引っかかった際に使用
    const rePasswordNavigate = (authKey: string) => {
        navigate(`/changePassword?authKey=${authKey}`);
    };

    // ログインボタン押下時のイベント
    const handleClickLogin = (userDetail: UserDetailResponse) => {
        const agreeTerms = userDetail.faxNumber;
        if (agreeTerms === "1") {
            loginNavigate();
        } else {
            // 初回ログイン時のみ規約表示
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            setAgreementOpen(true);
        }
    };

    const handleLogin = () => {
        if (Environments.MOCK) {
            sompoContext.setUserDetail(MOCK_DATA.USER_DETAIL.generalistsj);
            sompoContext.setUserSummary(MOCK_DATA.USER_SELECT_LIST.userList[0]);
            sompoContext.setUserImage(USER_IMAGE);
            login({
                accessToken: MOCK_DATA.LOGIN.accessToken,
                refreshToken: MOCK_DATA.LOGIN.refreshToken,
            });
            handleClickLogin(MOCK_DATA.USER_DETAIL.generalistsj);
        } else {
            const fetch = async () => {
                try {
                    await loginService.login(
                        {
                            loginId: formValues.loginId,
                            password: formValues.password,
                        },
                        (response: LoginResponse) => {
                            login(response);
                        },
                        (error: any) => {
                            throw error;
                        }
                    );

                    // ユーザ情報をfetch
                    // ユーザ情報の取得
                    const userDetail = await new Promise<UserDetailResponse>((resolve, reject) => {
                        return userDetailService.getUserDetail(resolve, reject);
                    });
                    await sompoContext.setUserDetail(userDetail);

                    // hotfix-202411: ログインIDの突合(入力⇔レスポンス)
                    if (formValues.loginId !== userDetail.loginId) {
                        // ログイン日時を記録
                        const timestamp = formatJSDate(new Date(), DateFormats.YYYYMMDDHHMMSSMI);
                        // 謎の必須項目補完用のプロパティを取得
                        const { lang, timeZone, countryCode, familyNameJa } = userDetail;
                        await userDetailService.saveUserDetail(
                            {
                                // 暫定で経歴等(汎用入力)に設定
                                careerMemoJa: `${timestamp}: Login failed. [input:${formValues.loginId}, response:${userDetail.loginId}]`,
                                // 謎の必須項目を補完
                                lang,
                                timeZone,
                                countryCode,
                                familyNameJa,
                            },
                            (result) => {
                                console.debug(result);
                            },
                            (error: unknown) => {
                                throw error;
                            }
                        );

                        // ログインは失敗扱い、ホーム画面を表示しない
                        throw Error(`${timestamp}: LoginId mismatch. [input: ${formValues.loginId}, response: ${userDetail.loginId}]`);
                    }

                    // ユーザ概要の取得
                    await userService.find(
                        userDetail.loginId,
                        (response: User) => {
                            sompoContext.setUserSummary(response);
                        },
                        (error: any) => {
                            throw error;
                        }
                    );

                    // 顔写真をfetch
                    userImageService.userImageDownload(
                        (base64Text: string) => {
                            sompoContext.setUserImage(base64Text);
                        },
                        (error: unknown) => {
                            // NOP.
                            console.warn("Failed to fetch user image.", error);
                        }
                    );

                    handleClickLogin(userDetail);
                } catch (error: any) {
                    console.error(error);
                    const messages = (error.message || "").split(":");
                    const message = messages[0];
                    if (message === ERROR_PASSWORD_POLICY) {
                        showErrorMessage({
                            message: "このパスワードはパスワードポリシー違反です。パスワードを変更してください",
                            error,
                            resolve: () => rePasswordNavigate(messages[1]),
                        });
                    } else if (message === ERROR_PASSWORD_EXPIRED) {
                        showErrorMessage({
                            message: ERROR_MESSAGE_PASSWORD_EXPIRED,
                            error,
                            resolve: () => rePasswordNavigate(messages[1]),
                        });
                    } else if (message === ERROR_ACCESS_LIMIT) {
                        showErrorMessage({
                            message: "ただいまアクセスが集中しておりログインできません。<br/>しばらく時間をおいて再度ログインしてください。",
                            error,
                        });
                    } else {
                        showErrorMessage({ message: "ログインに失敗しました。", error });
                        logout();
                    }
                }
            };
            void fetch();
        }
    };
    // ↑ ログイン画面で使用 ↑

    return (
        <>
            <Grid
                container
                direction="column"
                justifyContent={infoVisible ? "flex-start" : "center"}
                alignItems="center"
                flexWrap="nowrap"
                sx={{
                    height: "100dvh",
                    width: "100vw",
                    overflowY: "scroll",
                    backgroundImage: `url(${backImage})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                    backgroundSize: "cover",
                    mt: 0,
                    "@media (orientation: landscape)": {
                        justifyContent: desktop ? "center" : "flex-start",
                    },
                }}
                rowSpacing={2}
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: { xs: "80%", sx: "80%", md: "50%" },
                        borderRadius: "20px",
                        padding: 5,
                        my: 4,
                    }}
                >
                    <Grid item container direction="column" justifyContent="space-evenly" alignItems="center">
                        <Grid
                            item
                            sx={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 5,
                            }}
                        >
                            <Typography
                                variant="h1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    textAlign: "center",
                                }}
                            >
                                {"SOMPO Learning Hub"}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            container
                            direction="column"
                            spacing={5}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-evenly",
                                flexFlow: "column",
                            }}
                        >
                            <Grid item sx={{ backgroundColor: "transparent", width: { xs: "90%", ms: "80%", md: "80%" } }}>
                                <LoginTextField
                                    fullWidth
                                    sx={{ m: 1 }}
                                    name="loginId"
                                    value={formValues.loginId}
                                    onChange={handleChange}
                                    placeholder={"ログインID"}
                                />
                                <LoginTextField
                                    fullWidth
                                    placeholder={"パスワード"}
                                    sx={{ m: 1 }}
                                    name="password"
                                    value={formValues.password}
                                    onChange={handleChange}
                                    type={passwordVisible ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleClickShowPassword}
                                                    edge="end"
                                                    sx={{
                                                        marginLeft: "-35px",
                                                    }}
                                                >
                                                    {passwordVisible ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <BasicButton
                                    disabled={formValues.loginId === "" || formValues.password === ""}
                                    onClick={handleLogin}
                                    label="ログイン"
                                />
                            </Grid>

                            <Grid item>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        transition: "all 0.2s ease-in-out",
                                        "&:hover": {
                                            opacity: "0.7",
                                            cursor: "pointer",
                                        },
                                    }}
                                    onClick={() => {
                                        setReminderOpen(true);
                                    }}
                                >
                                    <Link color="#333">
                                        <Typography
                                            sx={{
                                                color: "#333",
                                                fontSize: "0.9rem",
                                            }}
                                        >
                                            パスワードを忘れた方
                                        </Typography>
                                    </Link>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <Grid
                    item
                    container
                    direction="column"
                    justifyContent="center"
                    spacing={1}
                    sx={{
                        width: { xs: "80%", sx: "80%", md: "50%" },
                        m: "0 auto",
                    }}
                >
                    <Grid item container justifyContent={desktop ? "flex-start" : "center"} alignItems="center" spacing={1}>
                        <InfoIcon sx={{ color: "#c00000" }} />
                        <Typography>{"管理者からのお知らせ"}</Typography>
                        <IconButton sx={{ display: desktop ? "none" : "block" }} onClick={handleClickShowInfo}>
                            {infoVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </Grid>
                    <Grid item sx={{ display: desktop ? "block" : infoVisible ? "block" : "none" }}>
                        <iframe
                            src="./information/information.html"
                            style={{
                                width: "100%",
                                minHeight: "260px",
                                border: "0px none",
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {agreementOpen && <Agreement open={agreementOpen} setOpen={setAgreementOpen} handleLogin={loginNavigate} />}
            {reminderOpen && <PasswordReminder open={reminderOpen} setOpen={setReminderOpen} />}
        </>
    );
}
